import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  FiUsers,
  FiSave,
  FiTrash2,
  FiPlus,
  FiSearch,
  FiUser,
  FiCheckCircle,
  FiXCircle,
  FiRefreshCw,
  FiEye,
  FiEdit2,
  FiBriefcase,
} from "react-icons/fi";
import axios from "axios";
import "./Settings.css";

const url = process.env.REACT_APP_BACKEND_URL;

const CompanySettings = () => {
  const { currentUser, company } = useAuth();
  const navigate = useNavigate();
  
  const [companyUsers, setCompanyUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Fetch company users
  const fetchCompanyUsers = async () => {
    if (!company) return;
    
    setLoading(true);
    setError("");
    
    try {
      const response = await axios.get(`${url}/api/company/${company._id || company.id}/users`);
      
      if (response.data.success) {
        const users = response.data.data?.users || response.data.data || [];
        setCompanyUsers(users);
      }
    } catch (err) {
      setError("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (company) {
      fetchCompanyUsers();
    }
  }, [company]);

  // Filter users
  const filteredUsers = companyUsers.filter(user =>
    user.Usercomp_sure_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.Usercomp_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.Usercomp_code?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Render company settings UI
  return (
    <div className="settings-page">
      <div className="settings-header">
        <h1>
          <FiBriefcase /> {company?.company_name} Settings
        </h1>
        <p>Manage users for your company</p>
      </div>

      <div className="settings-content">
        {/* Add your company-specific settings here */}
        <div className="user-management-section">
          <div className="section-header">
            <h3><FiUsers /> Company Users</h3>
            <button className="btn-primary" onClick={fetchCompanyUsers} disabled={loading}>
              <FiRefreshCw className={loading ? "spinning" : ""} /> Refresh
            </button>
          </div>

          {/* User list table */}
          <div className="users-table">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map(user => (
                  <tr key={user._id}>
                    <td>{user.Usercomp_sure_name}</td>
                    <td>{user.Usercomp_email}</td>
                    <td>
                      <span className={`role-badge role-${user.role}`}>
                        {user.role}
                      </span>
                    </td>
                    <td>
                      <span className={`status-badge ${user.Usercomp_status}`}>
                        {user.Usercomp_status}
                      </span>
                    </td>
                    <td>
                      <button className="btn-icon">
                        <FiEye />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySettings;